import moment from 'moment';
import 'moment/locale/de';
import 'moment/locale/sv';

moment.defineLocale('sv', { invalidDate: 'ogiltigt datum' });
moment.defineLocale('de', { invalidDate: 'ungültiges Datum' });

export const I18n = {
  moment: moment,
  labelTranslation: label => {
    let split = label.split(':');
    if ((split.length = 2)) {
      let split1 = Number.parseInt(split[1]);
      if (split[0] === 'month') {
        return moment()
          .month(split1)
          .format('MMMM');
      } else if (split[0] === 'weekday') {
        return moment()
          .isoWeekday(split1)
          .format('dddd');
      } else {
        return label;
      }
    } else {
      return label;
    }
  }
};
